import { render, staticRenderFns } from "./transferPrices.vue?vue&type=template&id=579499ce&scoped=true"
import script from "./transferPrices.vue?vue&type=script&lang=js"
export * from "./transferPrices.vue?vue&type=script&lang=js"
import style0 from "./transferPrices.vue?vue&type=style&index=0&id=579499ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579499ce",
  null
  
)

export default component.exports